import React, { ReactNode } from 'react'
import { injectIntl } from 'react-intl'

import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import getConstants from '../../../../constants'

import { convertStoreHours } from 'helpers/hourConverter'
import { Display } from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

const getHours = (props: any) => {
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
  const listOfDays = [
    'text_sunday',
    'text_monday',
    'text_tuesday',
    'text_wednesday',
    'text_thursday',
    'text_friday',
    'text_saturday',
  ]
  const today = new Date().getDay()
  const hours: Array<ReactNode> = []
  const modifiedDays = days.concat(days.splice(0, today))
  const modifiedList = listOfDays.concat(listOfDays.splice(0, today))

  for (var i = 0; i < modifiedDays.length; i++) {
    hours.push(
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-02"
      >
        {props.intl.formatMessage({ id: `${modifiedList[i]}_long` })} :
        {convertStoreHours(
          props.storeInfo[`${modifiedDays[i]}OpenAt`],
          props.storeInfo[`${modifiedDays[i]}CloseAt`],
          getConstants().SHOW_TIME_IN_MILITARY,
        )}
      </Body>,
    )
  }
  if (props.storeInfo[`holOpenAt`] && props.storeInfo[`holCloseAt`]) {
    hours.push(
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
      >
        {props.intl.formatMessage({ id: `text_holiday` })} :
        {convertStoreHours(
          props.storeInfo[`holOpenAt`],
          props.storeInfo[`holCloseAt`],
          getConstants().SHOW_TIME_IN_MILITARY,
        )}
      </Body>,
    )
  }

  return hours
}

const StoreHours = (props: any) => {
  return (
    <>
      <Display element="p" variant="display4" className="fr-ec-mb-spacing-04">
        {props.intl.formatMessage({ id: 'text_openinghour' })}
      </Display>
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-03"
      >
        {getHours(props)}
      </Body>
      {props.storeInfo.irregularOpenTimeComment ? (
        <Body
          className="fr-ec-mb-spacing-04"
          color="primary-dark"
          element="p"
          textAlign="left"
          textTransform="normal"
          variant="standard"
        >
          {props.intl.formatMessage({ id: 'text_irregular_opening_day' })}:{' '}
          {Parser(props.storeInfo.irregularOpenTimeComment)}
        </Body>
      ) : (
        <></>
      )}
      {props.storeInfo.temporaryCloseDateComment ? (
        <Body
          className="fr-ec-mb-spacing-02"
          element="p"
          textAlign="left"
          textTransform="normal"
          variant="standard"
        >
          {props.intl.formatMessage({ id: 'text_store_holiday' })}:{' '}
          {Parser(props.storeInfo.temporaryCloseDateComment)}
        </Body>
      ) : (
        <></>
      )}
    </>
  )
}

export default injectIntl(StoreHours)
